import React, { useCallback, useEffect, useState, useMemo } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Switch,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  UserOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import { AiOutlineMail, AiFillDelete } from "react-icons/ai";

import Swal from "sweetalert2";
import moment from "moment";

import { useSelector, useDispatch } from "react-redux";
import { userActions, roleActions } from "../store";
import userSystemApi from "../api/userSystemApi";
import debounce from "lodash.debounce";
import PERMISSION from "../consts/permissions";

const UserSystem = (props) => {
  // const { Search } = Input;
  const dispatch = useDispatch();
  const { userSystems, totalCount } = useSelector((x) => x.userSystem);
  const lstRoles = useSelector((x) => x.role.lstRoles);
  const { permissions } = useSelector((x) => x.auth);
  const [listPermissions, setPermissions] = useState(permissions);

  //   const [users, setUsers] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalEditContractVisible, setIsModalEditContractVisible] =
    useState(false);
  //   const [lstRoles, setRoles] = useState();
  const [btnDeleted, setBtnDeleted] = useState(false);
  const [listDeleted, setListDeleted] = useState("");
  const [titleModal, setTitleModal] = useState("");
  const [isEditModal, setEditModal] = useState(false);
  const [valueFormUser, setValueFormUser] = useState({
    id: null,
    username: null,
    fullName: null,
    password: null,
    email: null,
    active: false,
    roles: [],
  });
  const [inputFilter, setFilter] = useState({
    username: "",
    email: "",
    role: "",
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const dateFormat = "DD/MM/YYYY HH:mm:ss";
  const [form] = Form.useForm();

  useEffect(() => {
    getUserSystem();
    getRoles();
    form.setFieldsValue(valueFormUser);
  }, [inputFilter, form, valueFormUser, isEditModal]);

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      username: inputFilter.username,
      email: inputFilter.email,
      role: inputFilter.role,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Tên tài khoản",
      dataIndex: "username",
      render: (text) => <h6>{text}</h6>,
      sorter: true,
    },
    {
      title: "Họ và tên",
      dataIndex: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      render: (createdAt) => <>{moment(createdAt).format(dateFormat)} </>,
    },
    {
      title: "Ngày sửa",
      dataIndex: "updatedAt",
      render: (updatedAt) => <>{moment(updatedAt).format(dateFormat)} </>,
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      render: (status) => (
        <>
          {status === true && (
            <Tag color="green" key={status}>
              Hoạt động
            </Tag>
          )}
          {status === false && (
            <Tag color="red" key={status}>
              Bị khóa
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {listPermissions.includes(PERMISSION.Admin_UserSystem_Update) ? (
            <>
              <Button
                onClick={() => showEditModal(record)}
                value="large"
                icon={<EditOutlined />}
              >
                Sửa
              </Button>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_UserSystem_Delete) ? (
            <>
              <Button
                disabled={record.protected ? true : false}
                value="large"
                type="primary"
                icon={<DeleteOutlined />}
                danger
                onClick={() => deleteUser(record)}
              >
                Xóa
              </Button>
            </>
          ) : null}
        </Space>
      ),
      width: 150,
      className: "text-center",
    },
  ];

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    // console.log(
    //   `selectedRowKeys: ${newSelectedRowKeys}`,
    //   "selectedRows: ",
    //   selectedRows
    // );
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted("");
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.protected === true,
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, page: 1,username: e.target.value });
  };

  const handleSearchEmail = (e) => {
    setFilter({ ...inputFilter,page: 1, email: e.target.value });
  };

  const getUserSystem = () => {
    onSelectChange([], []);
    setLoading(true);
    dispatch(userActions.getAll(inputFilter)).then(() => {
      setLoading(false);
    });
  };
  const getUserDebounce = useMemo(() => debounce(handleSearch, 300), []);
  const getEmailDebounce = useMemo(() => debounce(handleSearchEmail, 300), []);

  const getRoles = () => {
    dispatch(roleActions.getAll());
  };

  const createUserSystem = (data) => {
    userSystemApi.createUser(data).then(
      (res) => {
        // console.log("res", res);
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo tài khoản thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditContractVisible(false);
          getUserSystem();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updateUserSystem = (data) => {
    userSystemApi.updateUser(data).then(
      (res) => {
        // console.log(res.data.data);
        if (res.status) {
          Swal.fire({
            title: "Thành Công!",
            text: res.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditContractVisible(false);
          getUserSystem();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const confirm = Modal.confirm;

  const deleteUser = (record) => {
    const data = record.id;
    confirm({
      title: "Bạn có muốn xóa tài khoản này không?",
      onOk() {
        // console.log(data);
        userSystemApi
          .deleteUser(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công tài khoản ");
              getUserSystem();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteUsers = () => {
    const data = {
      userIds: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các tài khoản này không?",
      onOk() {
        userSystemApi
          .deleteUsers(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công tài khoản ");
              getUserSystem();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const resetPassword = () => {
    const idUser = valueFormUser.id;

    userSystemApi.resetPassword(idUser).then(
      (res, status) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Thành công!",
            text: res.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditContractVisible(false);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const showEditModal = (record) => {
    setEditModal(true);
    setTitleModal("Sửa thông tin tài khoản");

    const rolesOfUsers = record.roles.map((item, key) => {
      if (lstRoles.filter((a) => a.id === item.id)) {
        return item;
      }
      return;
    });

    const roles = rolesOfUsers.map((item, key) => {
      return item.id;
    });

    setValueFormUser({
      id: record.id,
      username: record.username,
      fullName: record.fullName,
      password: null,
      email: record.email,
      active: record.active,
      roles: roles,
    });

    setIsModalEditContractVisible(true);
  };

  const showCreateModal = () => {
    setTitleModal("Thêm tài khoản");
    setValueFormUser({
      id: null,
      username: null,
      fullName: null,
      password: null,
      email: null,
      roles: [],
    });
    setEditModal(false);
    setIsModalEditContractVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        // const edit = Object.values(values).map((item) => {
        //   return Object.values(valueFormUser).filter((x) => x !== item);
        // });
        // console.log(edit);
        updateUserSystem(values);
      } else {
        createUserSystem(values);
      }
    },
    [isEditModal]
  );

  const closePopup = useCallback(() => {
    setValueFormUser({
      id: null,
      username: null,
      fullname: null,
      email: null,
      roles: [],
    });
    form.resetFields();
    setIsModalEditContractVisible(false);
  }, [form]);

  const { Option } = Select;

  const onChangeSelect = (value) => {
    console.log(`selected ${value}`);
  };

  const onSearch = (value) => {
    console.log("search:", value);
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tên tài khoản</label>
              <br />
              <Input
                addonAfter={<UserOutlined />}
                defaultValue={inputFilter.username}
                placeholder="Nhập tài khoản..."
                onChange={getUserDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6}>
              <label> Địa chỉ email</label>
              <Input
                addonAfter={<AiOutlineMail />}
                placeholder="Nhập địa chỉ email..."
                defaultValue={inputFilter.email}
                onChange={getEmailDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6}>
              <label className="">Lọc theo quyền</label>
              <br />

              <Select
                defaultValue={inputFilter.role}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                onChange={(e) => {
                  setFilter({ ...inputFilter,page: 1, role: e });
                }}
              >
                <Option value="">---Mặc định---</Option>
                {lstRoles == null || lstRoles === "undefined" || lstRoles === []
                  ? []
                  : lstRoles.map((item, key) => (
                      <Option key={key} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
              </Select>
            </Col>
          </Row>
        </Card>

        <br />
        <Space size={10}>
          {listPermissions.includes(PERMISSION.Admin_UserSystem_Update) ? (
            <>
              <Button
                type="dashed"
                onClick={() => showCreateModal()}
                size="smail"
              >
                <EditOutlined /> &nbsp; Thêm tài khoản
              </Button>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_UserSystem_Update) ? (
            <>
              {btnDeleted ? (
                <Button
                  value="smail"
                  type="primary"
                  icon={<AiFillDelete />}
                  danger
                  onClick={() => {
                    deleteUsers();
                  }}
                >
                  &nbsp; Xóa các tài khoản được chọn
                </Button>
              ) : null}
            </>
          ) : null}
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={userSystems}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>

        <Modal
          forceRender
          title={titleModal}
          visible={isModalEditContractVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              form={form}
              initialValues={valueFormUser}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              {isEditModal ? (
                <>
                  <Form.Item hidden={true} label="Id" name="id">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Tài khoản" name="username">
                    <Input disabled />
                  </Form.Item>
                </>
              ) : (
                <Form.Item
                  label="Tài khoản"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập tên tài khoản!",
                    },
                  ]}
                >
                  <Input
                    maxLength={30}
                    addonAfter={<UserOutlined />}
                    placeholder="Nhập tài khoản..."
                  />
                </Form.Item>
              )}

              <Form.Item
                label="Họ và tên"
                name="fullName"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập họ và tên!",
                  },
                ]}
              >
                <Input
                  maxLength={150}
                  addonAfter={<IdcardOutlined />}
                  placeholder="Nhập họ tên..."
                />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập email!",
                  },
                  {
                    type: "email",
                    message: "Email không đúng định dạng!",
                  },
                ]}
              >
                <Input
                  addonAfter={<AiOutlineMail />}
                  placeholder="Nhập email..."
                />
              </Form.Item>

              <Form.Item
                label="Roles"
                name="roles"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn role!",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  placeholder="Tìm role..."
                  optionFilterProp="children"
                  mode="multiple"
                  onChange={onChangeSelect}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {lstRoles == null ||
                  lstRoles === "undefined" ||
                  lstRoles === []
                    ? []
                    : lstRoles.map((item, key) => (
                        <Option key={key} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Trạng thái"
                valuePropName="checked"
                name="active"
              >
                <Switch />
              </Form.Item>

              {isEditModal ? (
                <>
                  <Form.Item label="Mật khẩu" name="password">
                    <Button
                      value="small"
                      type="primary"
                      onClick={() => resetPassword()}
                      style={{ background: "black", borderColor: "white" }}
                    >
                      Reset mật khẩu
                    </Button>
                  </Form.Item>
                </>
              ) : (
                <Form.Item
                  label="Mật khẩu"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              )}
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default UserSystem;
